var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "united-kingdom",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.3,
    height: 26,
    viewBox: "0 0 40.3 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M44.534,90.839h-13.3l-1.3,1.01h-3.9l-1.3-1.01h-13.3L8.5,92.139v24.005H45.586l2.545-1.626v-7.429l-1.043-1.3v-3.9l1.043-1.3V93.16Z",
    transform: "translate(-7.831 -90.839)",
    fill: "#5055a0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M35.5,142.7H5.2a3.9,3.9,0,0,1-3.9-3.9V120.692L0,120.324v7.429l.708.364v5.707l-.708.43v7.429L3.6,144H16.9l1.3-.888h3.9l1.3.888H36.7Z",
    transform: "translate(0 -118.003)",
    fill: "#3f3f8f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M56.666,90.89l-1.6.353L19.073,114.374l2.39,1.547L57.472,92.65l.31-.932A1.3,1.3,0,0,0,56.666,90.89Z",
    transform: "translate(-17.572 -90.886)",
    fill: "#e5646e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M3.091,384.55,1.109,386.6a1.3,1.3,0,0,0,1.117.827l3.309-1.361A3.893,3.893,0,0,1,3.091,384.55Z",
    transform: "translate(-1.022 -361.432)",
    fill: "#db4655"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M5.537,91.486,4.144,91.25c-.718,0-1.082.688-1.082,1.406V92.9l37.4,24.046L43,115.621Z",
    transform: "translate(-2.821 -91.218)",
    fill: "#e5646e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M459.9,404.645h-3.97l1.555.761,1.654.536a1.3,1.3,0,0,0,1.117-.827Z",
    transform: "translate(-420.046 -379.945)",
    fill: "#db4655"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M2.227,90.894a1.307,1.307,0,0,0-1.114.826l1.212,1.556V90.942Z",
    transform: "translate(-1.025 -90.89)",
    fill: "#db4655"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M47.9,101.889l-17.55-.65-.65-10.4H25.8l-.65,10.4H8.25v5.2h16.9v9.784h5.2v-9.784l17.55-.65Z",
    transform: "translate(-7.601 -90.839)",
    fill: "#e5646e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M0,227.518l1.3.65v-5.2l-1.3.65Z",
    transform: "translate(0 -212.568)",
    fill: "#db4655"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M227.518,405.945h-3.9l-.65-1.3h5.2Z",
    transform: "translate(-205.418 -379.945)",
    fill: "#db4655"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M298.974,280.774h-17.55a.65.65,0,0,0-.65.65v9.1l.613.613.687-.613v-7.283l11.288,7.282,2.235.674.163-.674-13.1-8.45h2.4l13.1,8.45.619.244.2-.244V289.5l-11.515-7.429h11.515Z",
    transform: "translate(-258.674 -265.824)",
    fill: "#f2f2f6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M25.151,280.774H8.9l-.651.65.651.65H19.116l-9.794,6.319-.482,1.044H10.1l11.411-7.362h2.4l-12.625,8.145.18.756,1.745-.451L24.5,283.241v7.282l.626.605.674-.605v-9.1a.65.65,0,0,0-.65-.65Z",
    transform: "translate(-7.601 -265.824)",
    fill: "#f2f2f6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M24.5,90.839v8.583L11.2,90.839H8.9c-.03,0-.069,0-.1,0l15.11,9.746h-2.4L8.9,92.451l-.408.578L8.9,94l10.215,6.59H8.9l-.651.65.651.65h16.25a.65.65,0,0,0,.65-.65v-10.4Z",
    transform: "translate(-7.601 -90.839)",
    fill: "#f2f2f6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M0,214.71H1.3v1.3H0Z",
    transform: "translate(0 -204.96)",
    fill: "#e1e1e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M1.3,102.166l-1.212-.782a1.3,1.3,0,0,0-.088.47v1.021l1.3.839Z",
    transform: "translate(0 -100.554)",
    fill: "#e1e1e6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M298.974,92.139a1.29,1.29,0,0,0-.09-.468l-13.823,8.918h-2.4l15.106-9.746c-.029,0-.065,0-.095,0h-2.3l-13.3,8.582V90.839h-1.3v10.4a.65.65,0,0,0,.65.65h17.55v-1.3H287.459l11.515-7.429Z",
    transform: "translate(-258.674 -90.839)",
    fill: "#f2f2f6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(0 14.95)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M0,280.774H1.3v1.3H0Z",
    transform: "translate(0 -280.774)",
    fill: "#e1e1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M2.5,378.613a3.91,3.91,0,0,1-.781-1.043L0,378.68V379.7a1.3,1.3,0,0,0,.087.469Z",
    transform: "translate(0 -369.951)",
    fill: "#e1e1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M214.71,404.645h1.3v1.3h-1.3Z",
    transform: "translate(-197.81 -394.895)",
    fill: "#e1e1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M280.774,404.645h1.3v1.3h-1.3Z",
    transform: "translate(-258.674 -394.895)",
    fill: "#e1e1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M17.7,402.378l2.015-1.3H19.3a3.888,3.888,0,0,1-1.513-.3l-2.482,1.6c.029,0,.065,0,.1,0Z",
    transform: "translate(-14.102 -391.328)",
    fill: "#e1e1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M280.774,404.645h1.3v1.3h-1.3Z",
    transform: "translate(-258.674 -394.895)",
    fill: "#e1e1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M502.363,405.115a1.3,1.3,0,0,0,.087-.47h-.816Z",
    transform: "translate(-462.151 -394.895)",
    fill: "#e1e1e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M443.1,404.645h-2.4l2.015,1.3h2.3c.03,0,.066,0,.1,0Z",
    transform: "translate(-406.013 -394.895)",
    fill: "#e1e1e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.801faa10489e6dba19e051dd585f0741.svg";
export { ForwardRef as ReactComponent };